/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import { DEFAULT_CURRENCY } from '../locales';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "flowChannelDefs",
    graphQL: "FlowChannelDef",
    name: "Flow Channel Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowChannelDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Channel Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
            required: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            required: true,
            validations: {
                matchRegexp: /^[a-zA-Z]+[a-zA-Z0-9_]*$/,
            },
        },
        doNotShowToUser: {
            name: "Do not show to user",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        disableAdding: {
            name: "Do not allow to select application",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        flowDescription: {
            name: "Flow description",
            type: "text",
            translatable: true,
            isPublic: true,
        },
        replaceFlowDescription: {
            name: "Replace flow description",
            type: "enum",
            defaultValue: "append",
            values: {
                "append": {
                    name: "Append at end",
                },
                "replace": {
                    name: "Replace description",
                },
            },
            isPublic: true,
        },
        overridePrices: {
            name: "Override flow prices",
            type: "boolean",
            defaultValue: false,
        },
        overridePricePerInvocation: {
            name: "Price per invocation",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePriceInstallation: {
            name: "Installation Price",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePriceInstallationNext: {
            name: "Installation Price (another)",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePriceSelfInstallation: {
            name: "Self Installation Price",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overrideTablePerInvocation: {
            name: "Table per invocation",
            type: "string",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePricePerInstance: {
            name: "Price per instance",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePricePerInstanceNext: {
            name: "Price per instance (more)",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overrideMinPrice: {
            name: "Minimum Price",
            type: "number",
            visibility: (data) => { return data['overridePrices']; },
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePriceText: {
            name: "Price text",
            type: "string",
            translatable: true,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        flowStepLinkDefs: {
            type: 'oneToMany',
            to: types['flowStepLinkDefs'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },
    }; }
});
